import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4 mt-8 shadow-inner">
      <div className="container mx-auto text-center px-4">
        <p className="text-sm">&copy; {new Date().getFullYear()} Blog especializado en temas de construcción en Estados Unidos. All rights reserved.</p>
        <p className="text-sm mt-2">
          <a href="https://construlabs.com/politica-de-privacidad/" className="hover:text-gray-400">Politica de privacidad</a> | 
          <a href="https://construlabs.com/contacto/" className="hover:text-gray-400 ml-2">Contacto</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
